/**
 * Gedeelde helpers voor de Section Rendering API en de jQuery-accordeon van het thema.
 *
 * Gebruikt door src/product-configurator.js (productinfo en FAQ per keuze ophalen) en
 * src/faq-sheet.js (accordeon in de gekopieerde FAQ). Wordt door esbuild in die bundels
 * meegenomen; dit bestand is zelf geen entry point (zie compile-js.js).
 */

/**
 * Haalt één section van een pagina op via de Section Rendering API en geeft die als Document terug.
 * @param {string} url - pagina-URL (mag al een querystring hebben)
 * @param {string} sectionId - bestandsnaam van de section zonder .liquid
 * @returns {Promise<Document>}
 */
export async function fetchSectionDocument(url, sectionId) {
  const target = new URL(url, window.location.origin);
  target.searchParams.set('section_id', sectionId);
  const response = await fetch(target.href);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return new DOMParser().parseFromString(await response.text(), 'text/html');
}

/** Initialiseert de .pt-accordeon-blokken binnen een element (jQuery-plugin uit theme.js, als die geladen is). */
export function initAccordeon(root) {
  if (window.jQuery && window.jQuery.fn.accordeon) window.jQuery(root).find('.pt-accordeon').accordeon();
}
